// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__18__R","validationTips":"StatementDescriptor_validationTips__3JAUR"};